import { USER_CENTERS, USER_RGHT } from "@/donor/components/state/actions/login";
import cookieUtils from "@/utils/cookieUtils";

export const SETISLOGIN = "SETISLOGIN";
export const SETUSERINF = "SETUSERINF";
export const SETUSERINFCENTER = "SETUSERINFCENTER";

export const COOKIE_NAME_TOKEN = 'token';
export const COOKIE_NAME_USER_INFO = 'user_info';

export const setIsLogin = (token) => {
    if (token) {
        cookieUtils.set(COOKIE_NAME_TOKEN, token);
    } else {
        cookieUtils.clear(COOKIE_NAME_TOKEN);
    }
    return ({
        type: SETISLOGIN,
        state: token,
    })
};

export const SetUserInfo = (userInfo) => {
    if (userInfo) {
        let user = {...userInfo}
        delete user.centers
        delete user.roleId
        const centers = localStorage.getItem(USER_CENTERS);
        cookieUtils.set(COOKIE_NAME_USER_INFO, JSON.stringify(user));
        const roleId = localStorage.getItem(USER_RGHT);
        if(userInfo.roleId) {
            localStorage.setItem(USER_RGHT, JSON.stringify(userInfo.roleId));
        } else {
            if (roleId) {
                const roleIdNew = JSON.parse(roleId);
                if(userInfo) {
                    userInfo.roleId = roleIdNew
                }
            }
        }
        if(userInfo.centers) {
            localStorage.setItem(USER_CENTERS, JSON.stringify(userInfo.centers));
        } else {
            if (centers) {
                const centersArray = JSON.parse(centers);
                if(userInfo) {
                    userInfo.centers = centersArray
                }
            }
        }
    } else {
        cookieUtils.clear(COOKIE_NAME_USER_INFO);
        localStorage.removeItem(USER_CENTERS);
        localStorage.removeItem(USER_RGHT);
    }
    console.log(``)
    return ({
    type: SETUSERINF,
    userInfo,
    })
};

export const GetUserInfo = (userInfo, isLogin) => {
    const centers = localStorage.getItem(USER_CENTERS);
    let user = cookieUtils.get(COOKIE_NAME_USER_INFO)
    let token = cookieUtils.get(COOKIE_NAME_TOKEN)
    const roleId = localStorage.getItem(USER_RGHT);
    let userNew = userInfo ? userInfo : user ? JSON.parse(user) : ''
    if(roleId) {
        const roleIdNew = JSON.parse(roleId);
        if(userNew) {
            userNew.roleId = roleIdNew
        }
    }
    if (centers) {
        const centersArray = JSON.parse(centers);
        if(userNew) {
            userNew.centers = centersArray
        }
    }
    return ({
        isLogin: isLogin ? isLogin : token ? token : '',
        userInfo: userNew
    })
};

export const SetUserInfoCenter = (center) => {
    if (userInfo) {
        cookieUtils.set(COOKIE_NAME_USER_INFO, JSON.stringify(userInfo));
    } else {
        cookieUtils.clear(COOKIE_NAME_USER_INFO);
    }
    return ({
    type: SETUSERINFCENTER,
    center,
    })
};